type FlowVolumePayload = {
  l?: unknown;
  m2?: unknown;
  m3?: unknown;
};

function hasValue(value: unknown): boolean {
  return value !== undefined && value !== null && value !== '';
}

function parseNumber(value: unknown): number | null {
  if (!hasValue(value)) {
    return null;
  }

  const parsed =
    typeof value === 'number' ? value : Number.parseFloat(String(value).trim().replace(',', '.'));

  return Number.isFinite(parsed) ? parsed : null;
}

export function getFlowVolumeThousandsValue(payload: FlowVolumePayload): unknown {
  return hasValue(payload.m3) ? payload.m3 : payload.m2;
}

export function parseFlowVolumeThousands(payload: FlowVolumePayload): number | null {
  return parseNumber(getFlowVolumeThousandsValue(payload));
}

export function getFlowTotalLiters(payload: FlowVolumePayload): number {
  const liters = parseNumber(payload.l) ?? 0;
  const thousands = parseFlowVolumeThousands(payload) ?? 0;

  return liters + thousands * 1000;
}
